export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/business_cards_stationery.06856af.svg";